import {BaseService} from "./baseService";
import {
    CreateStageRequest,
    CreateStageResponse,
    RemoveCoCommentatorInviteRequest,
    ReportContentRequest,
    ContentReportsResponse,
    ContentReportsFilters,
    SendCoCommentatorInviteRequest
} from "./types";

export class StageService extends BaseService {
    /**
     * Create a new stage for an event
     */
    static async createStage(
        eventKey: string
    ): Promise<CreateStageResponse> {
        try {
            const request: CreateStageRequest = {eventKey};
            const response = await this.post("/create", request);
            return await this.handleResponse<CreateStageResponse>(response);
        } catch (error) {
            console.error("Error creating stage:", error);
            throw error;
        }
    }

    static async sendCoCommentatorInvite(request: SendCoCommentatorInviteRequest): Promise<null> {
        try {
            const response = await this.post("/stages/invite", request);
            return await this.handleResponse<null>(response);
        } catch (error) {
            console.error('Error sending co-commentator invitation:', error);
            throw error;
        }
    }

    static async removeCoCommentatorInvite(request: RemoveCoCommentatorInviteRequest): Promise<null> {
        try {
            const response = await this.post("/stages/remove", request);
            return await this.handleResponse<null>(response);
        } catch (error) {
            console.error('Error removing co-commentator invitation:', error);
            throw error;
        }
    }

    static async reportContent(request: ReportContentRequest): Promise<null> {
        try {
            const response = await this.post("/stages/report", request);
            return await this.handleResponse<null>(response);
        } catch (error) {
            console.error('Error reporting content:', error);
            throw error;
        }
    }

    static async getContentReports(filters?: ContentReportsFilters): Promise<ContentReportsResponse> {
        try {
            const queryParams = new URLSearchParams();

            if (filters?.limit) queryParams.set('limit', filters.limit.toString());
            if (filters?.offset) queryParams.set('offset', filters.offset.toString());
            if (filters?.category) queryParams.set('category', filters.category);
            if (filters?.eventKey) queryParams.set('eventKey', filters.eventKey);

            const url = `/stages/report${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

            const response = await this.get(url);
            return await this.handleResponse<ContentReportsResponse>(response);
        } catch (error) {
            console.error('Error fetching content reports:', error);
            throw error;
        }
    }
}
